"use client"

import { EMAIL } from "@/assets/static/contact"
import ArrowForward from "@/assets/vectors/ArrowForward"
import HeartFilled from "@/assets/vectors/HeartFilled"
import MusicNote from "@/assets/vectors/MusicNote"
import Thread from "@/assets/vectors/Thread"
import dictionary from "@/utils/dictionary"
import Link from "next/link"
import { usePathname } from "next/navigation"
import styles from "./footer.module.scss"

export default function Footer() {
    const pathname = usePathname()
    if (pathname === '/resume') return null;

    return <footer className={styles.container}>
        <Thread className={styles.thread} />
        <div className={styles.wrapper} aria-label="Footer">
            <p dangerouslySetInnerHTML={{ __html: dictionary.global.copyright }} />
            <ul className={styles.list}>
                <li>
                    <MusicNote />
                    <Link className={styles.link} href="/music">
                        Music
                    </Link>
                    <ArrowForward className={styles.arrow_forward} />
                </li>

                <li>
                    <HeartFilled />
                    <a
                        className={styles.link}
                        href={`mailto:${EMAIL}?subject=Recommendation%20for%20Emran%20Hejazi&body=Hi%20Emran,%0A%0AI'd%20love%20to%20leave%20a%20recommendation%20for%20your%20portfolio:%0A%0A[Your%20Recommendation%20Here]%0A%0A-%20[Your%20Name]`}
                    >
                        {dictionary.global.leave_recommendation}
                    </a>
                    <ArrowForward className={styles.arrow_forward} />
                </li>
            </ul>
        </div>
    </footer>

}